import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TableWrapper = styled.div`
  width: fit-content;
  overflow-x: auto;
`;
const WIDTH = 100;
const tableColumns = [
  {
    columns: [
      {
        Header: 'Month',
        accessor: 'Month',
        width: 200,
      },
      {
        Header: '#Assigned',
        accessor: 'Assigned',
        width: WIDTH,
      },

      {
        Header: '#Active',
        accessor: 'Active',
        width: WIDTH,
      },
      {
        Header: '% Overall',
        accessor: 'Overall',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% Goals',
        accessor: 'Goals',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% CW',
        accessor: 'CW',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% HW/ANY',
        accessor: 'HW/ANY',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% Mandatory',
        accessor: 'Mandatory',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% Optional',
        accessor: 'Optional',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% Assessment',
        accessor: 'Assessment',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        Header: '% Puzzle',
        accessor: 'Puzzle',
        Cell: ({ value }) => (value ? value + '%' : ''),
        width: WIDTH,
      },
      {
        accessor: 'position',
        width: 0,
        show: false,
      },
    ],
  },
];

class CompletionTable extends PureComponent {
  render() {
    const { completionData } = this.props;
    const sortByPosition = [{ id: 'position', desc: true }];
    return (
      <TableWrapper>
        <ReactTable
          data={completionData}
          className="-striped -highlight"
          columns={tableColumns}
          defaultSorted={sortByPosition}
          style={{ textAlign: 'left' }}
        />
      </TableWrapper>
    );
  }
}

CompletionTable.propTypes = {
  completionData: PropTypes.arrayOf(PropTypes.shape({})),
};

CompletionTable.defaultProps = {
  completionData: null,
};

export default CompletionTable;
